module.exports = __webpack_public_path__ + "img/url-link-icon.1a192294.svg";